{
    "actions": {
        "page": {
            "add_organization": "Nouvelle organisation",
            "add_direct_organization": "Nouvelle sous-organisation",
            "update_organization": "Modifier l'organisation",
            "update_subdomain": "Modifier le sous-domaine",
            "update_brand": "Modifier la personnalisation",
            "add_existing_plan": "Ajouter une offre existante",
            "update_type": "Modifier le type",
            "add_user": "Nouvel utilisateur monétique",
            "update_sim_offers": "Modifier les forfaits SIM"
        }
    },
    "details": {
        "connection_points": {
            "port_type": {
                "SIMPLEAUTH": "Profil SSL : SIMPLEAUTH (STCA)",
                "STCA_INGET": "Profil SSL : STCA_INGET"
            },
            "public_ip": {
                "custom_site": "{{ip}} - {{site}}",
                "site": "{{ip}} - Site {{site}}",
                "no_site": "{{ip}}"
            },
            "port": {
                "redirected": "{{port}} - Port redirigé (SSLv3, TLSv1.0, TLSv1.1, TLSv1.2)",
                "tlsv1_2": "{{port}}  - TLSv1.2"
            }
        },
        "legal_infos": {
            "title": "Informations légales",
            "disclaimer": "Les informations ci-dessous sont issues du RCS."
        },
        "alerts": {
            "add_emails": "Ajouter des emails",
            "configure_alerts": "Configurer les alertes",
            "delete_mail": "Effacer cet email",
            "new_pos_connections": {
                "title": "Connexions nouveaux TPE"
            },
            "not_set": "Aucune alerte email configurée",
            "consumption": {
                "title": "Consommation des cartes SIM",
                "sim_cards": {
                    "title": "Cartes SIM",
                    "configured": "Alertes SIM activées avec un seuil de {{threshold}}%",
                    "non_configured": "Aucune alerte carte SIM configurée"
                },
                "sim_groups": {
                    "title": "Groupes de SIM",
                    "configured": "Alertes groupe de SIM activées avec un seuil de {{threshold}}%",
                    "non_configured": "Aucune alerte groupes de SIM configurée"
                },
                "receivers_one": "Destinataire de l'alerte",
                "receivers_other": "Destinataires des alertes"
            }
        },
        "sim_offers": {
            "sierra_wireless": {
                "name": "Sierra Wireless",
                "manage": "Gestion des forfaits SIM (Sierra Wireless)"
            },
            "deutsche_telekom": {
                "name": "Deutsche Telekom",
                "manage": "Gestion des forfaits SIM (Deutsche Telekom)"
            },
            "service": {
                "name": "SIM service",
                "manage": "Gestion des forfaits SIM (SIM service)"
            },
            "bouygues_telecom": {
                "name": "Bouygues Telecom",
                "manage": "Gestion des forfaits SIM (Bouygues Telecom)"
            }
        }
    },
    "keys": {
        "registration_number": "SIRET",
        "legal_name": "Nom de l'organisation",
        "business_name": "Nom commercial",
        "type": "Type d'organisation",
        "created_at": "Créée le",
        "updated_at": "MAJ le",
        "ports": "Ports",
        "comment": "Commentaire",
        "client_code": "Code client",
        "billing_id_read": "ID de facturation",
        "billable": "Facturable",
        "push_payments_legal_name": "Partenaire(s) Push Payment",
        "head_office_registration_number": "SIREN",
        "branch_business_sector_label": "Activité principale",
        "company_long_name": "Nom complet",
        "legal_nature_label": "Forme juridique",
        "legal_address": "Adresse",
        "creation_date": "Date de création",
        "update_date": "Date de mise à jour",
        "brand_domain_name": "Nom de domaine",
        "main_color": "Couleur principale",
        "brand_logo": "Logo",
        "connection_point_ip_address": "Adresse IP",
        "connection_point_port": "Port associé",
        "no_legal_info": "Aucune information légale trouvée",
        "more_legal_info": "Plus d'informations sur"
    },
    "filter": {
        "placeholder": {
            "legal_name": "Filtrer par nom de l'organisation",
            "registration_number": "Filtrer par SIRET",
            "business_name": "Filtrer par nom commercial"
        }
    },
    "form": {
        "error": {
            "INVALID_REGISTRATION_NUMBER": "Veuillez saisir un numéro de SIRET valide"
        }
    },
    "modal": {
        "update_subdomain": {
            "title": "Modifier le sous-domaine",
            "success": "Le sous-domaine est modifié avec succès !",
            "error": {
                "default": "Une erreur est survenue lors de la modification du sous domaine",
                "already_used": "Le sous-domaine que vous souhaitez est déjà attribué"
            }
        },
        "add_organization": {
            "title": "Nouvelle organisation",
            "info": "Aucune information trouvée pour le SIRET donné",
            "registration_number": "Numéro de SIRET",
            "success": "L'organisation a été ajoutée avec succès !",
            "steps": {
                "registration_number": "Étape {{step}} sur {{maxStep}} : Saisie du numéro de SIRET",
                "organization_info": "Étape {{step}} sur {{maxStep}} : Saisie des informations de l'organisation"
            }
        },
        "update_organization": {
            "title": "Modifier l'organisation",
            "billable_options": {
                "true": "Oui",
                "false": "Non"
            },
            "success": "Organisation modifiée avec succès !",
            "error": {
                "default": "Une erreur est survenue lors de la modification de l'organisation"
            }
        },
        "update_brand": {
            "title": "Modifier la personnalisation",
            "success": "Personnalisation modifiée avec succès !",
            "error": {
                "default": "Une erreur est survenue lors de la modification de la personnalisation"
            },
            "logo": {
                "info1": "Caractéristiques :",
                "info2": "Formats acceptés : PNG, JPG, JPEG",
                "info3": "Taille maximale : 200 Ko",
                "upload": "Importer un logo",
                "delete": "Supprimer le logo",
                "error": "Le fichier est trop lourd ou le format n'est pas supporté"
            },
            "color": {
                "error": "Champ obligatoire: Couleur"
            }
        },
        "delete_mail": {
            "title": "Supprimer un email",
            "message": "L'email {{email}} sera supprimé et ne recevra plus d'alertes.",
            "confirm": "Voulez-vous continuer ?",
            "success": "Email supprimé avec succés !"
        },
        "add_emails": {
            "title_new_pos": "Alertes connexions nouveaux TPE",
            "title_consumption": "Alertes consommation des cartes SIM",
            "message": "Vous pouvez encore créer {{emailsNumber}} alertes emails.",
            "confirm": "L'email suivant recevra des alertes :",
            "blocked": "Veuillez configurer une alerte avant d'ajouter des emails",
            "max_emails_number_reached": "Vous ne pouvez plus créer d’alertes par e-mail\n(nombre maximum de {{emailsNumber}} emails atteint)",
            "success": "Email(s) ajouté(s) avec succès !"
        },
        "configure": {
            "title": "Modifier les alertes",
            "threshold": "Seuil pour l'alerte",
            "success": "Configuration des alertes effectuée avec succès !",
            "sim_cards": {
                "title": "Cartes SIM",
                "message": "Envoyer une alerte pour les SIM dont la consommation du mois dépasse le seuil."
            },
            "sim_groups": {
                "title": "Groupes de SIM",
                "message": "Envoyer une alerte pour les groupes de SIM dont la consommation du mois dépasse le seuil."
            }
        },
        "update_organization_type": {
            "title": "Modifier le type",
            "success": "Organisation transformée en Marque Blanche avec succès ! Veuillez ajouter le port.",
            "error": {
                "default": "Une erreur est survenue lors de la transformation de l'organisation en Marque Blanche",
                "already_used": "Le sous-domaine que vous souhaitez est déjà attribué"
            }
        },
        "update_sim_offers": {
            "title": "Modifier les forfaits SIM",
            "subtitle": "Forfaits SIM",
            "show_all": "Afficher tout",
            "no_data": "Vous ne possédez actuellement aucun forfait SIM associé à votre organisation.",
            "success": "Forfait mis à jour avec succès !",
            "error": "Une erreur est survenue lors de la mise à jour du forfait SIM"
        },
        "errors": {
            "UNKNOWN_ERROR": "Une erreur inconnue est survenue.",
            "ORGANIZATION_ALREADY_EXISTS": "Une organisation avec ce nom existe déjà"
        }
    },
    "type": {
        "WHITE_LABEL": "Marque blanche",
        "MERCHANT": "Marchand"
    }
}